import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {BarAlert} from '../../model/bar-alert.model';


export type BarAlertState = {
  isActive: boolean;
  alert: BarAlert;
};

const initialState: BarAlertState = {
  isActive: false,
  alert: undefined
};

export const BarAlertSignalStore = signalStore(
  {providedIn: 'root'},
  withState(initialState),
  withMethods((store) => ({
    updateAlert(isActive: boolean, alert: BarAlert): void {
      patchState(store, {isActive, alert});
    }
  }))
);
